class Tooltips{

	constructor() {

		let tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
		let tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

	}

}